import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import finacraft_api from "../api_adapters/finacraft_api";

export default function AppEntry() {
  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;

    async function fetchOnboardingStatus() {
      try {
        const { data } = await finacraft_api.get("/core_api/clients/onboarding-status/");
        if (!isMounted) return;

        if (data.onboarding_completed) {
          navigate("/dashboard", { replace: true });
        } else {
          navigate("/onboarding", { replace: true });
        }
      } catch (error) {
        console.error("Failed to fetch onboarding status", error);
      }
    }

    fetchOnboardingStatus();
    return () => {
      isMounted = false;
    };
  }, [navigate]);

  return null;
}
